import styled, { css } from 'styled-components';
import { colors, shadows } from 'src/config/colors';
import { media } from 'src/config/breakpoints';

export const AuthBox = styled.div`
  background: ${colors.white};
  box-shadow: ${shadows.drop1};
  border-radius: 0.5rem;
  margin: 0 auto;
  max-width: 72.1875rem;
  padding: 1.875rem 0.75rem 3.125rem;

  ${media.w.min.px576(css`
    padding: 3.0625rem 1.5rem 2.375rem;
  `)};

  ${media.w.min.px992(css`
    display: flex;
    padding: 2.25vw 2.5vw;
  `)};

  ${media.w.min.px1440(css`
    padding: 2rem 2.25rem;
  `)};
`;
